export default __webpack_public_path__ + "static/media/telegram.e3a0eb84.svg";